import React, { useMemo, useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import useOrganizations from 'src/dataHooks/useOrganizations';
import useOrganizationBanks from 'src/dataHooks/useOrganizationBanks';
import PageSpin from 'src/components/PageSpin';
import Text from 'src/components/Text';
import styles from './styles.module.scss';
import HelpLink from 'src/components/HelpLink';

// Если организация или банк передан через роутер при навигации с предыдущей страницы,
// то дополнительно ничего грузить не надо, но возможен вариант перехода по прямой ссылке
// или обратного редиректа из авторизации, тогда данные нужно загрузить
const useOrganization = () => {
  const { organizations, fetchOrganizations } = useOrganizations();
  const location = useLocation();
  const params = useParams();

  const organization = useMemo(() => {
    return (
      location.state?.organization ||
      organizations?.find(
        ({ organizationUeid }: any) => organizationUeid === params.organizationUeid
      )
    );
  }, [location.state, params.organizationUeid, organizations]);

  useEffect(() => {
    if (!location.state?.organization) {
      fetchOrganizations();
    }
  }, [fetchOrganizations, location.state]);

  return organization;
};

const useBank = () => {
  const { organizationBanks, fetchOrganizationBanks } = useOrganizationBanks();
  const location = useLocation();
  const params = useParams();

  const bank = useMemo(() => {
    return location.state?.bank ?? organizationBanks?.find((bank: any) => bank.ueid === params.bankUeid);
  }, [location.state, params.bankUeid, organizationBanks]);

  useEffect(() => {
    if (!location.state?.bank) {
      fetchOrganizationBanks(params.organizationUeid);
    }
  }, [fetchOrganizationBanks, location.state, params.organizationUeid]);

  return bank;
};

const Title: React.FC = () => {
  const organization = useOrganization();
  const bank = useBank();

  if (!organization || !bank) {
    return <PageSpin />;
  }

  return (
    <div className={styles['root']}>
      <Text type="h1" className={styles['title']}>
        Список ТСП для организации {organization.name} и банка {bank.name}
      </Text>
      <HelpLink className={styles['help']}/>
    </div>
  );
};

export default Title;
